import '../globalThisPolyfill.js';
import '../../../../../js/shared/collapseContent.js';
import '../../../../../js/shared/generateRandomId.js';
import '../../../../../js/shared/jquery.serialize.js';
import '../../../../../js/shared/RegexManager.js.es6';
import '../../../../../es6/shared/collapse-content.js.es6';
import '../../../../../es6/shared/dayjs-plugins-init.js.es6';
import '../../../../../es6/shared/debounce.js.es6';
import '../../../../../es6/shared/cookie.js.es6';
import '../../../../../es6/shared/debug.js.es6';
import '../../../../../es6/shared/default_form_handler.js.es6';
import '../../../../../es6/shared/expiring_data_manager.js.es6';
import '../../../../../es6/shared/field_autosave_manager.js.es6';
import '../../../../../es6/shared/fill_variables.js.es6';
import '../../../../../es6/shared/flash_alert.js.es6';
import '../../../../../es6/shared/form_validation.js.es6';
import '../../../../../es6/shared/google_login_manager.js.es6';
import '../../../../../es6/shared/in-view-test-function.js.es6';
import '../../../../../es6/shared/in-view.js.es6';
import '../../../../../es6/shared/jquery-safe-selectors.js.es6';
import '../../../../../es6/shared/jquery.autoexpand.js.es6';
import '../../../../../es6/shared/jquery.elementStateHelper.js.es6';
import '../../../../../es6/shared/jquery.onIntersection.js.es6';
import '../../../../../es6/shared/log.js.es6';
import '../../../../../es6/shared/lory_carousel.js.es6';
import '../../../../../es6/shared/performance-tracker.js.es6';
import '../../../../../es6/shared/pikaday.js.es6';
import '../../../../../es6/shared/preload.js.es6';
import '../../../../../es6/shared/raf.es6';
import '../../../../../es6/shared/random.js.es6';
import '../../../../../es6/shared/ab-tests-helper.js.es6';
import '../../../../../es6/shared/regex_validator.js.es6';
import '../../../../../es6/shared/session-flash.es6';
import '../../../../../es6/shared/setup.js.es6';
import '../../../../../es6/shared/social_login_error.js.es6';
import '../../../../../es6/shared/spinner.js.es6';
import '../../../../../es6/shared/storage_manager.js.es6';
import '../../../../../es6/shared/tags_autocomplete.js.es6';
import '../../../../../es6/shared/tags_storage.js.es6';
import '../../../../../es6/shared/temporary_storage_manager.js.es6';
import '../../../../../es6/shared/timezones.js.es6';
import '../../../../../es6/shared/track_click.js.es6';
import '../../../../../es6/shared/track.js.es6';
import '../../../../../es6/shared/user-data.js.es6';
import '../../../../../es6/shared/wait-for.js.es6';
import '../../../../../es6/shared/wish_list.js.es6';
import '../../../../../es6/views/login/facebook-auth.js.es6';
import '../../../../../js/views/shared/detect_device.js';
import '../../../../../js/views/shared/single_page_menu.js';
import '../../../../../js/views/shared/ds_textarea_handler.js.es6';
import '../../../../../js/views/shared/fix_tooltips.js.es6';
import '../../../../../js/views/shared/input_chars_counter.js.es6';
import '../../../../../components/locale-links.js.es6';
import '../../../../../components/locale-manager.js.es6';
import '../../../../../components/locale-auto-set.js.es6';

import { preloadRoomCardHoverInteractions } from '@/services/room-card-prefetcher';

preloadRoomCardHoverInteractions();
